import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { AlarmTypesParams } from './service';

export enum AlarmTypesActions {
  Failure = '[Catalogs AlarmTypes] Failure',
  Request = '[Catalogs AlarmTypes] Request',
  Success = '[Catalogs AlarmTypes] Success',
}

export const AlarmTypesFailure = createAction(AlarmTypesActions.Failure, props<{ error: HttpErrorResponse }>());

export const AlarmTypesRequest = createAction(AlarmTypesActions.Request, props<{ parameters?: AlarmTypesParams }>());

export const AlarmTypesSuccess = createAction(AlarmTypesActions.Success, props<{ data: ParameterResult[] }>());
